import React, {
    useEffect,
    useState
} from "react";


import {
    useNavigate
} from "react-router-dom";


import {
    notificationApi
} from "../../api/notificationApi";


import {
    Notification
} from "../../types/notification";


import "../../styles/NotificationBell.css";



const BellIcon = () => (
    <svg
        viewBox="0 0 24 24"
        width="20"
        height="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
        <path d="M13.7 21a2 2 0 0 1-3.4 0" />
    </svg>
);

export default function NotificationBell(){

    const navigate =
        useNavigate();



    const [
        notifications,
        setNotifications
    ] =
        useState<Notification[]>([]);



    const [
        open,
        setOpen
    ] =
        useState(false);



    const [
        count,
        setCount
    ] =
        useState(0);




    const loadNotification =
        async()=>{

        try{

            const data =
                await notificationApi.getAll();


            setNotifications(data);



            const unread =
                await notificationApi.getUnreadCount();


            setCount(unread);


        }
        catch(error){

            console.error(
                "Load notification error",
                error
            );

        }

    };





    useEffect(()=>{

        loadNotification();


        const timer =
            setInterval(
                loadNotification,
                30000
            );


        return ()=>clearInterval(timer);


    }, []);







    const handleClick =
        async(
            item: Notification
        )=>{


        if(!item.isRead){

            await notificationApi.markRead(
                item.id
            );

        }




        if(
    item.type === "CONTACT_LEAD"
    ||
    item.type === "CONTACT"
){

    navigate(
        "/admin-dashboard?tab=contact"
    );

            return;

        }




        if(
            item.type === "NEWS_PUBLISHED" ||
            item.type === "NEWS_SCHEDULED_PUBLISHED"
        ){

            navigate(
                "/admin-dashboard?tab=news"
            );

            return;

        }




        if(item.targetUrl){

            navigate(
                item.targetUrl
            );

        }


    };





    return (

        <div
            className="notification-wrapper"
        >


            <button
                className="notification-button"
                onClick={()=>
                    setOpen(!open)
                }
            >

                <BellIcon />


                {
                    count > 0 &&
                    <span
                        className="notification-count"
                    >
                        {count}
                    </span>
                }


            </button>





            {
                open &&

                <div
                    className="notification-dropdown"
                >

                    <h3>
                        Thông báo
                    </h3>



                    {
                        notifications.length === 0 ?

                        (
                            <p>
                                Không có thông báo
                            </p>
                        )

                        :

                        notifications.map(
                            item=>(

                            <div
                                key={item.id}
                                className={
                                    item.isRead
                                    ?
                                    "notification-item"
                                    :
                                    "notification-item unread"
                                }
                                onClick={()=>
                                    handleClick(item)
                                }
                            >

                                <strong>
                                    {item.title}
                                </strong>


                                <p>
                                    {item.message}
                                </p>


                            </div>

                        ))

                    }


                </div>

            }


        </div>

    );
}